import { getCurrentInstance, inject } from 'vue';

import { clients, ClientType, ClientsType } from '@api/client';

type UseClientType = {
  client: ClientType,
};

export const useClient = (
  key: keyof ClientsType,
): {
  client: ClientType,
} => {
  if (getCurrentInstance()) {
    const injectedClients = inject('$clients');
    if (injectedClients) {
      return { client: injectedClients[key] } as UseClientType;
    }
  }

  return { client: clients[key] } as UseClientType;
};
